export const removeEmptyStringFromObject = (obj: Record<string, any>) => {
  Object.keys(obj).forEach((key) => obj[key] === '' && delete obj[key]);
  return obj;
};
